import api from "../../../../services/axiosConfig";
import createModuleApi from "../../../../services/createModuleApi";

const crud = createModuleApi("/instances/skeye/skeyenote", {
  endpoints: {
    list: "/users",
    create: "/user/add",
    update: "/user/modify",
    delete: "/user/delete",
  },
});

export const fetchUsers = crud.fetchAll;
export const addUser = crud.create;
export const deleteUser = async (username) => {
  const res = await api.delete(
    `/instances/skeye/skeyenote/user/delete/${username}`,
  );
  return res.data;
};

export const modifyUser = async (user) => {
  const res = await api.put("/instances/skeye/skeyenote/user/modify", user);
  return res.data;
};

export const fetchRoles = async () => {
  const res = await api.get("/instances/skeye/skeyenote/roles", { data: {} });
  return res.data.data.roles;
};

export const addRole = async (roleName) => {
  const res = await api.post(`/instances/skeye/skeyenote/role/add/${roleName}`);
  return res.data;
};

export const deleteRole = async (roleName) => {
  const res = await api.delete(
    `/instances/skeye/skeyenote/role/delete/${roleName}`,
  );
  return res.data;
};

export const changeEmail = async (username, email) => {
  const res = await api.put(
    `/instances/skeye/skeyenote/user/change-email/${username}`,
    { email },
  );
  return res.data;
};

export const resetPassword = async (username, password) => {
  const res = await api.put(
    `/instances/skeye/skeyenote/user/reset-password/${username}`,
    { password },
  );
  return res.data;
};

export const assignRole = async (username, roleName) => {
  const res = await api.post(
    `/instances/skeye/skeyenote/user/assign-role/${username}/${roleName}`,
  );
  return res.data;
};

export const removeRole = async (username, roleName) => {
  const res = await api.delete(
    `/instances/skeye/skeyenote/user/remove-role/${username}/${roleName}`,
  );
  return res.data;
};
